// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393760750824",
  numero_telefono: "tel:+39082442927",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  */

  urlWeb: 'https://scuolalatecnica.discentya.it/',
  urlMaterialeDidattico: 'https://scuolalatecnica.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://scuolalatecnica.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://scuolalatecnica.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://scuolalatecnica.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://scuolalatecnica.discentya.it/api/',

  urlStampa: 'https://scuolalatecnica.discentya.it/stampe/',

  urlAttestati: 'https://scuolalatecnica.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://scuolalatecnica.discentya.it/pages/certificate/',
  urlImagePartners: 'https://scuolalatecnica.discentya.it/assets/media/partners/',

};

